import { createAppSelector, sectionSelectors, selectCurrentSectionId } from "./base";
import { OrgCapability, hasOrgCapability, selectCurrentUserOrgRole } from "./permissions";

import { RootState } from "store";
import { isLinkedSection } from "utils/publishing";

export const selectIsSidebarOpen = (state: RootState) => state.local.isSidebarOpen;

// Edit mode is not allowed for linked sections.  So we ignore the store value in that case.
export const selectIsEditModeEnabled = createAppSelector(
  [selectCurrentSectionId, (state) => state.local.editMode, sectionSelectors.selectEntities],
  (sectionId, editMode, sections) =>
    sectionId && sectionId in sections && isLinkedSection(sections[sectionId]) ? false : editMode,
);

export const selectIsEditingOrgSettings = createAppSelector(
  [selectIsEditModeEnabled, selectCurrentUserOrgRole],
  (isEditModeEnabled, userOrgRole) =>
    isEditModeEnabled && hasOrgCapability(userOrgRole, OrgCapability.CAN_AUTHOR_ORG),
);

export const selectLastHomeRole = (state: RootState) => state.local.lastHomeRole;

export const selectLastSectionViewOption = (state: RootState) => state.local.lastSectionViewOption;

export const selectLocalMicIsEnabled = (state: RootState) => state.local.localAvState?.isMicEnabled;

export const selectLocalCameraIsEnabled = (state: RootState) =>
  state.local.localAvState?.isCameraEnabled;

export const selectPreferredMicDeviceLabel = (state: RootState) =>
  state.local.localAvState?.preferredMicDeviceLabel || null;

export const selectPreferredCameraDeviceLabel = (state: RootState) =>
  state.local.localAvState?.preferredCameraDeviceLabel || null;

export const selectIsBackgroundBlurEnabled = (state: RootState) =>
  state.local.localAvState?.isBackgroundBlurEnabled;

export const selectWasAutoMuted = (state: RootState) => state.local.localAvState?.wasAutoMuted;

export const selectLastAutoMuteScenario = (state: RootState) =>
  state.local.localAvState?.lastAutoMuteScenario;

export const selectClassChatReadAtForCurrentSection = createAppSelector(
  [selectCurrentSectionId, (state) => state.local.classChatReadAt],
  (sectionId, classChatReadAt) => {
    return sectionId && sectionId in classChatReadAt ? new Date(classChatReadAt[sectionId]) : null;
  },
);

export const selectApiError = (state: RootState) => state.local.apiError;

export const selectUserAgentInfo = (state: RootState) => state.local.userAgentInfo;

export const selectIsDesktopDevice = (state: RootState) =>
  state.local.userAgentInfo?.isDesktopDevice || false;
